import React from "react";
import { Checkbox } from "@progress/kendo-react-inputs";
import "./checkBox-template.css";
import { FieldWrapper } from "@progress/kendo-react-form";

const CheckBoxTemplatePure = (props) => {
  const { title } = props;

  return (
    < div className="container-checkBox" >
      <FieldWrapper>
        <Checkbox className="style-checkbox" {...props} />
      </FieldWrapper>
    </div >
  );
};

export { CheckBoxTemplatePure as default };
